/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { GroupBase, OptionsOrGroups } from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Optional } from 'utility-types';
import { IDropdown, getDropdownComponents } from '../Dropdown';
import { IDropdownOption } from '../../types';

export interface IDropdownPaginate extends Optional<IDropdown, 'options'> {
  onChange?: (value: IDropdownOption) => void;
  loadOptions: (
    search: string,
    loadedOptions: OptionsOrGroups<unknown, GroupBase<unknown>>,
    additional?: any
  ) => Promise<{ options: IDropdownOption[]; hasMore: boolean; additional?: any }>;
  defaultOptions?: boolean;
}

const DropdownPaginate = forwardRef<any, IDropdownPaginate>(
  ({ className, containerClassName, error, label, isClearable, value, onChange, loadOptions, ...rest }, ref) => {
    return (
      <div className={containerClassName}>
        {label}
        <AsyncPaginate
          value={value}
          onChange={(value) => onChange?.(value as IDropdownOption)}
          loadOptions={loadOptions}
          selectRef={ref}
          {...getDropdownComponents(className, isClearable)}
          {...rest}
        />
        {error}
      </div>
    );
  }
);

DropdownPaginate.displayName = 'DropdownPaginate';

export default DropdownPaginate;
